import axios from 'axios';

const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
const UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

/**
 * Cloudinary'ye medya (Görsel veya Video) yükler.
 * @param {File} file - Yüklenecek dosya
 * @param {string} resourceType - 'image' veya 'video'
 */
export const uploadMedia = async (file, resourceType = 'image') => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', UPLOAD_PRESET);

  try {
    const response = await axios.post(
      `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/${resourceType}/upload`,
      formData
    );
    // Yüklenen medyanın güvenli linkini (HTTPS) döner
    return response.data.secure_url;
  } catch (error) {
    console.error(`Cloudinary ${resourceType} yükleme hatası:`, error);
    throw error;
  }
};